import React, { useState, useEffect } from 'react';
import './App.css';
import TeklifForm from './components/TeklifForm';
import TeklifOnizleme from './components/TeklifOnizleme';
import { TeklifBilgisi, UrunBilgisi } from './types';

// Bugünün tarihini ve şu anki saati al
const bugun = new Date();
const tarihStr = `${bugun.getDate().toString().padStart(2, '0')}.${(bugun.getMonth() + 1).toString().padStart(2, '0')}.${bugun.getFullYear()}`;
const saatStr = `${bugun.getHours().toString().padStart(2, '0')}:${bugun.getMinutes().toString().padStart(2, '0')}`;

const defaultTeklif: TeklifBilgisi = {
  alici: '', // Boş olarak ayarlandı
  tarih: tarihStr, // Bugünün tarihi
  saat: saatStr, // Şu anki saat
  urunler: [
    { id: '1', metrekare: 1, aciklama: '', birimFiyat: 1, satisToplam: 1 } // Sadece 1 ürün
  ],
  toplamTutar: 1, // Başlangıç toplamı
  kdvDahil: true
};

function App() {
  const [teklifBilgisi, setTeklifBilgisi] = useState<TeklifBilgisi>(defaultTeklif);

  useEffect(() => {
    // Toplam tutarı hesapla
    const toplam = teklifBilgisi.urunler.reduce((acc, urun) => acc + urun.satisToplam, 0);
    setTeklifBilgisi(prev => ({
      ...prev,
      toplamTutar: toplam
    }));
  }, [teklifBilgisi.urunler]);

  const handleTeklifGuncelle = (yeniTeklif: TeklifBilgisi) => {
    setTeklifBilgisi(yeniTeklif);
  };

  return (
    <div className="App">
      <div className="container">
        <h1>Teklif PDF Oluşturucu</h1>
        <div className="app-layout">
          <div className="form-container">
            <TeklifForm teklifBilgisi={teklifBilgisi} onGuncelle={handleTeklifGuncelle} />
          </div>
          <div className="preview-container">
            <TeklifOnizleme teklifBilgisi={teklifBilgisi} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App; 